// extracted by mini-css-extract-plugin
export default {"connection-status-banner":"ConnectionStatusBanner_connection-status-banner__h+N+z"};